import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "role-dialog"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
import { reactive, computed, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { addOrganUserApi, updateOrganUserByIdApi } from "@/service/modules/organ";
export default /*@__PURE__*/_defineComponent({
  __name: 'organ-user-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    editRoleItem: {
      type: Object,
      default: () => {}
    },
    dialogType: {
      type: String,
      default: "addSubset"
    },
    itemData: {
      type: Object,
      default: () => {}
    },
    organList: {
      type: Array,
      default: () => []
    }
  },
  emits: ["closeDialog", "restData"],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const props = __props;
    const emit = __emit;
    const formRef = ref();
    const subBtnLoading = ref(false);
    const phoneReg = /^1[3456789]\d{9}$/gi;
    const form = reactive({
      realname: "",
      institutionId: null,
      mobile: "",
      status: 1
    });
    const id = ref(null);
    const rules = {
      realname: [{
        required: true,
        message: "请输入姓名",
        trigger: "blur"
      }],
      institutionId: [{
        required: true,
        message: "请选择机构",
        trigger: "change"
      }],
      mobile: [{
        required: true,
        message: "请输入手机号码",
        trigger: "blur"
      }, {
        pattern: phoneReg,
        message: "请输入正确的手机格式",
        trigger: "blur"
      }],
      status: [{
        required: true,
        message: "请选择状态",
        trigger: "change"
      }]
    };
    function restForm() {
      id.value = null;
      form.realname = "";
      form.institutionId = null;
      form.mobile = "";
      form.status = 1;
    }
    function closeDialog() {
      if (subBtnLoading.value) return ElMessage.warning("正在保存，请稍后~~");
      restForm();
      emit("closeDialog");
    }
    function handleFooterBtn(actionType) {
      if (!actionType) {
        closeDialog();
        return;
      }
      formRef.value?.validate(valid => {
        if (valid) {
          submit();
        }
      });
    }
    async function submit() {
      subBtnLoading.value = true;
      try {
        if (props.dialogType === "add") {
          let query = JSON.parse(JSON.stringify(form));
          await addOrganUserApi(query);
          ElMessage.success("添加成功");
        } else if (props.dialogType === "edit") {
          await updateOrganUserByIdApi(id.value, form);
          ElMessage.success("修改成功");
        }
        subBtnLoading.value = false;
        closeDialog();
        emit("restData");
      } catch {
        subBtnLoading.value = false;
      }
    }
    const title = computed(() => {
      if (props.dialogType === "add") {
        return "添加人员";
      } else if (props.dialogType === "edit") {
        return "编辑人员";
      }
    });
    watch(() => props.dialogVisible, newV => {
      if (newV && props.dialogType === "edit") {
        id.value = props.itemData.id;
        form.realname = props.itemData.realname;
        form.institutionId = props.itemData.institutionId * 1;
        form.mobile = props.itemData.mobile;
        form.status = props.itemData.status;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: title.value,
        width: "25%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_2, [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: subBtnLoading.value,
          onClick: _cache[5] || (_cache[5] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("确定")])),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form,
          rules: rules,
          "label-width": "80px",
          "status-icon": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "姓名",
            prop: "realname"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.realname,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.realname = $event),
              placeholder: "请输入姓名"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "所属机构",
            prop: "institutionId"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.institutionId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.institutionId = $event),
              filterable: "",
              placeholder: "请选择所属机构",
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.organList, item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "手机号码",
            prop: "mobile"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.mobile,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.mobile = $event),
              placeholder: "请输入手机号码"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "是否启用",
            prop: "status"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: form.status,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.status = $event),
              "active-value": 1,
              "inactive-value": 0
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["model-value", "title"])]);
    };
  }
});